import {CardData} from '../data/active_data/field_config/card_stack_data/CardData';
import {DrawHolder} from '../pixi_scene/DrawHolder';

export class DrawController
{
    static drawHolder: DrawHolder;
    private static _zoomed: boolean;

    public static get zoomed(): boolean {
        return DrawController._zoomed;
    }

    static start(drawHolder: DrawHolder): void {
        DrawController.drawHolder = drawHolder;
        DrawController.drawHolder.visible = false;
    }

    /**
     * Вызвать событие показа карты
     * @param cardData - данные карты
     */
    static async zoomCard(cardData: CardData): Promise<void> {
        await DrawController.drawHolder.zoomCard(cardData);
        DrawController.drawHolder.visible = DrawController._zoomed = true;
    }

    static unzoom(): void {
        DrawController.drawHolder.visible = DrawController._zoomed = false;
    }
}
